import { z } from 'zod';
/**
 * Shared Zod primitives. Kollez uses these across API validation and web form validation.
 */
/** Mongo ObjectId hex string. */
export const objectId = z.string().regex(/^[a-f\d]{24}$/i, 'Invalid ObjectId');
/** Email — lowercased on parse. */
export const email = z.string().email().toLowerCase();
/** Indian mobile — 10 digits, must start with 6-9. */
export const indianPhone = z
    .string()
    .regex(/^[6-9]\d{9}$/, 'Enter a 10-digit Indian mobile number');
/** Password policy: ≥10 chars, upper+lower+digit+symbol. */
export const password = z
    .string()
    .min(10, 'At least 10 characters')
    .regex(/[a-z]/, 'Needs a lowercase letter')
    .regex(/[A-Z]/, 'Needs an uppercase letter')
    .regex(/\d/, 'Needs a digit')
    .regex(/[^A-Za-z0-9]/, 'Needs a symbol');
/** OTP — 6 digits. */
export const otp = z.string().regex(/^\d{6}$/, 'Enter the 6-digit code');
/** CGPA 0–10 with up to 2 decimals. */
export const cgpa = z.number().min(0).max(10).multipleOf(0.01);
/** Percentage 0–100 with up to 2 decimals. */
export const percentage = z.number().min(0).max(100).multipleOf(0.01);
/** URL — HTTPS preferred but not required. */
export const url = z.string().url();
/** ISO date string coerced to Date. */
export const dateString = z.coerce.date();
/** Pagination query. */
export const paginationQuery = z.object({
    page: z.coerce.number().int().min(1).default(1),
    limit: z.coerce.number().int().min(1).max(100).default(20),
    sort: z.string().optional(),
});
/** Standard API response envelope (success). */
export const successEnvelope = (dataSchema) => z.object({
    ok: z.literal(true),
    data: dataSchema,
    meta: z
        .object({
        requestId: z.string().optional(),
        page: z.number().optional(),
        limit: z.number().optional(),
        total: z.number().optional(),
    })
        .optional(),
});
/** Standard API error envelope. */
export const errorEnvelope = z.object({
    ok: z.literal(false),
    error: z.object({
        code: z.string(),
        message: z.string(),
        details: z.unknown().optional(),
    }),
    meta: z.object({ requestId: z.string().optional() }).optional(),
});
//# sourceMappingURL=common.js.map